import { useIsAr } from '../../Hooks';

import { REQUEST_STATUSES } from '../../configs/enums';

import styles from './Steps.module.scss';

function Steps({ steps = [] }) {
  const [isAr, locale] = useIsAr();

  function getStyle(status) {
    if (status === REQUEST_STATUSES.SUBMITTED) return 'is-active';
    if (status === REQUEST_STATUSES.APPROVED) return 'is-active';
    if (status === REQUEST_STATUSES.PENDING) return 'is-pending';
    if (status === REQUEST_STATUSES.REJECTED) return 'rejected';
    return '';
  }

  return (
    <ul className={`list-unstyled ${styles.stepsContainer}`}>
      {steps.length > 0 ? (
        <>
          {steps.map((item, i) => (
            <li
              className={`${styles[getStyle(item.Status)]} ${styles[locale]}`}
              key={item.ID}
            >
              {isAr ? item.ArabicName : item.EnglishName}
            </li>
          ))}
        </>
      ) : null}
    </ul>
  );
}

export default Steps;
